"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundAccountStatus = exports.PaymentGatewayProvider = exports.TDSStatus = exports.PaymentStatus = exports.propsObjectKeys = exports.PaymentTransactionJobStatus = exports.BulkTransactionStatus = void 0;
var BulkTransactionStatus;
(function (BulkTransactionStatus) {
    BulkTransactionStatus["CREATED"] = "CREATED";
    BulkTransactionStatus["ALL_REGISTERED"] = "ALL_REGISTERED";
    BulkTransactionStatus["PARTIALLY_REGISTERED"] = "PARTIALLY_REGISTERED";
    BulkTransactionStatus["NOT_REGISTERED"] = "NOT_REGISTERED";
})(BulkTransactionStatus || (exports.BulkTransactionStatus = BulkTransactionStatus = {}));
var PaymentTransactionJobStatus;
(function (PaymentTransactionJobStatus) {
    PaymentTransactionJobStatus["CREATED"] = "CREATED";
    PaymentTransactionJobStatus["PICKED"] = "PICKED";
    PaymentTransactionJobStatus["COMPLETED"] = "COMPLETED";
})(PaymentTransactionJobStatus || (exports.PaymentTransactionJobStatus = PaymentTransactionJobStatus = {}));
/** Keys allowed for props filtering. Add here when extending PropsObject. */
exports.propsObjectKeys = ['projectId', 'taskIds'];
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["CREATED"] = "CREATED";
    PaymentStatus["PROCESSING"] = "PROCESSING";
    PaymentStatus["PROCESSED"] = "PROCESSED";
    PaymentStatus["FAILED"] = "FAILED";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
var TDSStatus;
(function (TDSStatus) {
    TDSStatus["PENDING"] = "PENDING";
    TDSStatus["PROCESSED"] = "PROCESSED";
    TDSStatus["FAILED"] = "FAILED";
})(TDSStatus || (exports.TDSStatus = TDSStatus = {}));
var PaymentGatewayProvider;
(function (PaymentGatewayProvider) {
    PaymentGatewayProvider["ICICI"] = "ICICI";
    PaymentGatewayProvider["CASHFREE"] = "CASHFREE";
})(PaymentGatewayProvider || (exports.PaymentGatewayProvider = PaymentGatewayProvider = {}));
var FundAccountStatus;
(function (FundAccountStatus) {
    FundAccountStatus["CREATED"] = "CREATED";
    FundAccountStatus["PENDING_VERIFICATION"] = "PENDING_VERIFICATION";
    FundAccountStatus["VERIFIED"] = "VERIFIED";
    FundAccountStatus["REJECTED"] = "REJECTED";
    FundAccountStatus["FAILED"] = "FAILED";
})(FundAccountStatus || (exports.FundAccountStatus = FundAccountStatus = {}));
//# sourceMappingURL=Index.js.map